module.exports = __webpack_public_path__ + "img/Jesse.3662ea56.jpg";